"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UtilIconClose = void 0;
var react_1 = __importDefault(require("react"));
var IconBase_1 = __importDefault(require("../IconBase"));
var utils_1 = require("../utils");
var ActionClose = function (props) { return (react_1.default.createElement(IconBase_1.default, __assign({}, props),
    react_1.default.createElement("path", { d: "M12 9.75973L16.56 5.19973C17.2 4.55973 18.16 4.55973 18.8 5.19973C19.44 5.83973 19.44 6.79973 18.8 7.43973L14.24 11.9997L18.8 16.5597C19.44 17.1997 19.44 18.1597 18.8 18.7997C18.16 19.4397 17.2 19.4397 16.56 18.7997L12 14.2397L7.43997 18.7997C6.79997 19.4397 5.83997 19.4397 5.19997 18.7997C4.55997 18.1597 4.55997 17.1997 5.19997 16.5597L9.75997 11.9997L5.19997 7.43973C4.55997 6.79973 4.55997 5.83973 5.19997 5.19973C5.83997 4.55973 6.79997 4.55973 7.43997 5.19973L12 9.75973Z" }))); };
exports.UtilIconClose = (0, utils_1.withDeprecationWarning)(ActionClose, 'UtilIconClose');
exports.default = ActionClose;
